import React from "react"
import { observer } from "mobx-react-lite"
import { View, ViewStyle, Dimensions, Platform } from "react-native"
import { StackScreenProps } from "@react-navigation/stack"

import {  HomeScreenProps } from "@app/navigators"
import { Button, Screen, Text, Svg } from "@app/components"
import { color } from "@app/theme"
import { Footer } from "@app/components/footer/footer"
import { Feather } from "@expo/vector-icons"
import { textPresets } from "@app/components/button/button.presets"
import NewcustomerPage from "@app/components/third-party/newcustomer/page"
import { CompositeScreenProps } from "@react-navigation/native"
import { HomeNavigatorParamList } from "@app/navigators/navigator-params"

export type ExternalScreenProps = CompositeScreenProps<
  StackScreenProps<HomeNavigatorParamList, "ExternalA" | "ExternalB">,
  HomeScreenProps
>
export const ExternalScreen = observer((props: ExternalScreenProps) => {
  const goBack = () => {
    if (props.navigation.canGoBack()) {
      props.navigation.goBack()
    } else {
      props.navigation.navigate("Tabs", { screen: "Home", params: { screen: 'Offers'} })
    }
  }

  const { slug, dealerId } = props.route.params

  return (
    <Screen style={ROOT} preset="scroll">
      <View style={PAGE_WRAPPER}>
        <View style={BACKGROUND_IMAGE}>
          <Svg preset="PinkBlob" />
        </View>
        <Button preset="back" onPress={goBack}>
          <Feather style={textPresets.back} name="chevron-left" />
          <Text style={textPresets.back} text="Tillbaka" />
        </Button>
        {Platform.OS === "web" && <NewcustomerPage slug={slug} dealerId={dealerId} />}
        {/* {!loading && <Markdown>{data.faqPage.data?.attributes?.markdown}</Markdown>} */}
      </View>
      <Footer />
    </Screen>
  )
})

const ww = Dimensions.get("window").width
const wh = Dimensions.get("window").height

const ROOT: ViewStyle = {
  backgroundColor: color.palette.white,
  minHeight: Dimensions.get("window").height}

const PAGE_WRAPPER: ViewStyle = {
  paddingVertical: 24,
  paddingBottom: 80,
  maxWidth: 840,
  width: "100%",
  minHeight: wh,
  alignSelf: "center"
}

const BACKGROUND_IMAGE: ViewStyle = {
  height: 500,
  width: 580,
  position: "absolute",
  top: -100,
  left: -200,
  transform: ww > 768 ? [{ scale: 2 }, { rotate: "45deg" }] : [{ scale: 1 }, { rotate: "45deg" }],
  zIndex: -1
}
